import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

class Modal extends Component {
  static propTypes = {
    tContent: PropTypes.string.isRequired,
    onRef: PropTypes.func,
  };

  static defaultProps = {
    onRef: null,
  };

  state = { isOpen: false };

  componentDidMount() {
    const { onRef } = this.props;
    if (typeof onRef === 'function') {
      onRef(this);
    }
  }

  close = () => {
    this.setState({ isOpen: false });
  };

  open = () => {
    this.setState({ isOpen: true });
  };

  render() {
    const { intl, tContent } = this.props;
    const classes = classNames('Modal', { 'Modal--open': this.state.isOpen });

    return (
      <div className={classes}>
        <div className="Modal__overlay" onClick={this.close} />
        <div className="Modal__content">
          <span className="Modal__close" onClick={this.close} />

          <section className="Modal__text" dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: tContent }) }} />
        </div>
      </div>
    );
  }
}

export default injectIntl(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal.js